module.exports = __webpack_public_path__ + "img/slow_motion_video.881a857d.svg";